import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-hot-toast";
import { CREATE_DISTRIBUTOR_API,GET_DISTRIBUTOR_API,SUBMIT_DISTRIBUTOR_API, UPLOAD_DISTRIBUTOR_API } from "src/config/apiConfig";
import { DistributorRequest, SubmitRequest } from "src/models/master_data/distributor/distributor.dto";

export const fetchMsDistributorThunk = createAsyncThunk(
    'msDistributor/fetchMsDistributorThunk',
    async (
        {
            pageNumber,
            pageSize,
            sortBy = 'Id', 
            sortOrder = 'asc',
            query = ''
        }: {
            pageNumber: number;
            pageSize: number;
            sortBy?: string;
            sortOrder?: string;
            query?: string
        },
        thunkAPI) => {
        try {
            const accessToken = localStorage.getItem('userToken');
            const headers = accessToken ? { Authorization: `Bearer ${accessToken}` } : {};

             // Transform sortBy to camelCase where the first letter is uppercase
             const formattedSortBy = sortBy.charAt(0).toUpperCase() + sortBy.slice(1);

            const response = await axios.get(`${GET_DISTRIBUTOR_API}`, {
                params: {
                    PageNumber: pageNumber,
                    PageSize: pageSize,
                    SortBy: formattedSortBy,
                    SortOrder: sortOrder,
                    Query: query
                },
                headers: {
                    ...headers,
                },
            });
            if (response.status === 200) {
                return response.data;
            } else {
                toast.error('Failed to fetch documents');
                return thunkAPI.rejectWithValue('Failed to fetch documents');
            }
        } catch (error: any) {
            toast.error(error.response?.data?.message || 'An error occurred while fetching documents');
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

export const createMsDistributorThunk = createAsyncThunk(
    'msDistributor/createMsDistributorThunk',
    async (priceData: DistributorRequest, thunkAPI) => {
        try {
            const response = await axios.post(CREATE_DISTRIBUTOR_API, priceData);
            if (response.status === 200 || response.status === 201) {
                toast.success('Distributor created successfully');
                return { data: response.data };
            } else {
                toast.error('Failed to create distributor');
                return thunkAPI.rejectWithValue('Failed to create distributor');
            }
        } catch (error: any) {
            toast.error(error.response?.data?.errorMessage || 'An error occurred while creating the distributor');
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const uploadMsDistributorThunk = createAsyncThunk(
    'msDistributor/uploadMsDistributorThunk',
    async (file: File, thunkAPI) => {
        const formData = new FormData();
        formData.append('file', file);

        try {
            const response = await axios.post(UPLOAD_DISTRIBUTOR_API, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            if (response.status === 200) {
                toast.success('File uploaded successfully');
                return { data: response.data };
            } else {
                toast.error('Failed to upload file');
                return thunkAPI.rejectWithValue('Failed to upload file');
            }
        } catch (error: any) {
            toast.error(error.response?.data?.errorMessage || 'An error occurred while uploading the file');
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const submitMsDistributorThunk = createAsyncThunk(
    'msDistributor/submitMsDistributorThunk',
    async (submitData: SubmitRequest, thunkAPI) => {
        try {
            const response = await axios.post(SUBMIT_DISTRIBUTOR_API, submitData);
            if (response.status === 200) {
                toast.success('Distributor submitted successfully');
                return { data: response.data };
            } else {
                toast.error('Failed to submit distributor');
                return thunkAPI.rejectWithValue('Failed to submit distributor');
            }
        } catch (error: any) {
            toast.error(error.response?.data?.errorMessage || 'An error occurred while submitting distributor');
            return thunkAPI.rejectWithValue(error);
        }
    }
);